// ══════════════════════════════════════════════
//  iseeit.jp — オプション価格評価ツール
//  Monte Carlo + Greeks + Yahoo Finance 連携
// ══════════════════════════════════════════════

let device = null, webgpuOK = false;
let pipeline = null;
let pathChart = null;
let currentType = 'euro';
const WG_LIMIT = 65535;

// ── ログ ──
function log(msg) {
  const box = document.getElementById('logBox');
  box.innerHTML += msg + '<br>';
  box.scrollTop = box.scrollHeight;
}
function clearLog() { document.getElementById('logBox').innerHTML = ''; }
function setProgress(pct) {
  document.getElementById('progWrap').style.display = pct > 0 && pct < 100 ? 'block' : 'none';
  document.getElementById('progBar').style.width = pct + '%';
}

// ── データソースタブ ──
function switchDs(ds) {
  document.querySelectorAll('.ds-tab').forEach(t => t.classList.toggle('active', t.dataset.ds === ds));
  document.getElementById('dsManual').classList.toggle('active', ds === 'manual');
  document.getElementById('dsYahoo').classList.toggle('active', ds === 'yahoo');
}

// ── オプションタイプ ──
function selectType(type) {
  currentType = type;
  document.querySelectorAll('.type-tab').forEach(t => t.classList.toggle('active', t.dataset.type === type));
  document.getElementById('barrierBox').style.display = (type === 'barrier') ? 'block' : 'none';
  // アジアン/バリアはマルチステップが必要 → STEPSを自動調整の案内
  if (type === 'euro') {
    document.getElementById('predLabel').textContent = 'ヨーロピアン 理論価格';
  } else if (type === 'asian') {
    document.getElementById('predLabel').textContent = 'アジアン 理論価格';
  } else {
    document.getElementById('predLabel').textContent = 'バリア 理論価格';
  }
  // 経路依存タイプで STEPS=1 のままなら日次(252)に引き上げる
  if (type !== 'euro') {
    const stepsSel = document.getElementById('pSteps');
    if (parseInt(stepsSel.value) < 2) {
      stepsSel.value = '252';
    }
  }
}

// ── パラメータ取得 ──
function getParams() {
  const barrierType = document.getElementById('pBarrierType').value;
  return {
    s0:    parseFloat(document.getElementById('pS0').value),
    k:     parseFloat(document.getElementById('pK').value),
    sigma: parseFloat(document.getElementById('pSig').value) / 100,
    r:     parseFloat(document.getElementById('pR').value) / 100,
    t:     parseFloat(document.getElementById('pT').value),
    steps: parseInt(document.getElementById('pSteps').value),
    numPaths: parseInt(document.getElementById('pN').value),
    isCall: document.getElementById('pType').value === 'call',
    barrier: parseFloat(document.getElementById('pBarrier').value),
    isKnockOut: barrierType.includes('out'),
    isUp: barrierType.includes('up'),
    optType: currentType,
  };
}

// ── 入力バリデーション ──
// 数値入力(S0,K,バリア)は空欄・負値・NaN・極端な値を弾く。
// ログにエラーを出し、問題があれば false を返す。
function validateParams(p) {
  const errors = [];

  // S0: 正の有限数
  if (!isFinite(p.s0) || p.s0 <= 0) {
    errors.push('S₀（現在株価）は正の数を入力してください');
  }
  // K: 正の有限数
  if (!isFinite(p.k) || p.k <= 0) {
    errors.push('K（権利行使価格）は正の数を入力してください');
  }
  // 極端な乖離（計算が無意味になる）
  if (isFinite(p.s0) && isFinite(p.k) && p.s0 > 0 && p.k > 0) {
    const ratio = p.k / p.s0;
    if (ratio > 100 || ratio < 0.01) {
      errors.push('S₀ と K が極端に乖離しています（比率は 0.01〜100 の範囲を推奨）');
    }
  }
  // バリア: バリアタイプ選択時のみ
  if (p.optType === 'barrier') {
    if (!isFinite(p.barrier) || p.barrier <= 0) {
      errors.push('バリア水準は正の数を入力してください');
    } else {
      // Up系: バリアは現在価格より上が自然 / Down系: 下が自然
      if (p.isUp && p.barrier <= p.s0) {
        errors.push('Up系バリアは現在株価 S₀ より高く設定するのが一般的です');
      }
      if (!p.isUp && p.barrier >= p.s0) {
        errors.push('Down系バリアは現在株価 S₀ より低く設定するのが一般的です');
      }
    }
  }
  // σ・r・T はスライダー/選択式なので通常は範囲内だが念のため
  if (!isFinite(p.sigma) || p.sigma <= 0) {
    errors.push('σ（ボラティリティ）が不正です');
  }
  if (!isFinite(p.t) || p.t <= 0) {
    errors.push('T（満期）が不正です');
  }
  // アジアン/バリアはマルチステップが必要
  if ((p.optType === 'asian' || p.optType === 'barrier') && p.steps < 2) {
    errors.push(`${p.optType === 'asian' ? 'アジアン' : 'バリア'}オプションは STEPS を 2 以上にしてください（経路全体が必要です）`);
  }

  if (errors.length > 0) {
    errors.forEach(e => log(`<span class="err">[入力エラー]</span> ${e}`));
    return false;
  }
  return true;
}

// ── WGSL ──
const WGSL = `
struct Params {
  s0: f32, k: f32, sigma: f32, r: f32,
  t: f32, isCall: f32, barrier: f32, isKnockOut: f32,
  isUp: f32, _pad0: f32, _pad1: f32, _pad2: f32,
  numPaths: u32, steps: u32, optType: u32, seed: u32,
}
@group(0) @binding(0) var<storage, read_write> payoffs: array<f32>;
@group(0) @binding(1) var<uniform> p: Params;

fn pcg(n: u32) -> u32 {
  var h = n * 747796405u + 2891336453u;
  h = ((h >> ((h >> 28u) + 4u)) ^ h) * 277803737u;
  return (h >> 22u) ^ h;
}
fn rand(seed: u32) -> f32 { return f32(pcg(seed)) / 4294967295.0; }
fn randNormal(seed: u32) -> f32 {
  let u1 = max(rand(seed * 2u), 1e-7);
  let u2 = rand(seed * 2u + 1u);
  return sqrt(-2.0 * log(u1)) * cos(6.2831853 * u2);
}

@compute @workgroup_size(64)
fn main(@builtin(global_invocation_id) gid: vec3u,
        @builtin(num_workgroups) nwg: vec3u) {
  let totalThreads = nwg.x * 64u;
  var pathId = gid.x;
  loop {
    if (pathId >= p.numPaths) { break; }
    let dt = p.t / f32(p.steps);
    let drift = (p.r - 0.5 * p.sigma * p.sigma) * dt;
    let volStep = p.sigma * sqrt(dt);
    var s = p.s0;
    var sumS = 0.0;
    var hit = false;
    for (var step = 0u; step < p.steps; step = step + 1u) {
      let z = randNormal(pathId * p.steps + step + p.seed);
      s = s * exp(drift + volStep * z);
      sumS = sumS + s;
      if (p.isUp > 0.5) { if (s >= p.barrier) { hit = true; } }
      else { if (s <= p.barrier) { hit = true; } }
    }
    var payoff = 0.0;
    let vanilla = select(max(p.k - s, 0.0), max(s - p.k, 0.0), p.isCall > 0.5);
    if (p.optType == 0u) {
      payoff = vanilla;
    } else if (p.optType == 1u) {
      let avgS = sumS / f32(p.steps);
      payoff = select(max(p.k - avgS, 0.0), max(avgS - p.k, 0.0), p.isCall > 0.5);
    } else {
      if (p.isKnockOut > 0.5) { payoff = select(vanilla, 0.0, hit); }
      else { payoff = select(0.0, vanilla, hit); }
    }
    payoffs[pathId] = payoff;
    pathId = pathId + totalThreads;
  }
}`;

// ── 初期化 ──
async function init() {
  selectType('euro');
  log('<span class="info">[INIT]</span> WebGPU を確認中...');
  if (!navigator.gpu) {
    setupCpuOnly('WebGPU非対応');
    return;
  }
  try {
    const adapter = await navigator.gpu.requestAdapter();
    device = await adapter.requestDevice();
    const module = device.createShaderModule({ code: WGSL });
    const info = await module.getCompilationInfo();
    for (const m of info.messages) if (m.type === 'error') throw new Error(m.message);
    pipeline = device.createComputePipeline({ layout: 'auto', compute: { module, entryPoint: 'main' } });
    webgpuOK = true;
    const badge = document.getElementById('backendBadge');
    badge.textContent = 'BACKEND: WebGPU ✓';
    badge.className = 'backend-badge ok';
    document.getElementById('btnPrice').disabled = false;
    document.getElementById('btnGreeks').disabled = false;
    log('<span class="ok">[OK]</span> WebGPU 初期化完了');
  } catch(e) {
    setupCpuOnly('WebGPU初期化失敗');
  }
}
function setupCpuOnly(reason) {
  webgpuOK = false;
  const badge = document.getElementById('backendBadge');
  badge.textContent = 'BACKEND: CPU';
  badge.className = 'backend-badge';
  document.getElementById('btnPrice').disabled = false;
  document.getElementById('btnGreeks').disabled = false;
  log('<span class="warn">[WARN]</span> ' + reason + '。CPU で計算します');
}

// ── uniform ──
function makeUniform(params, seed) {
  const ab = new ArrayBuffer(64);
  const fv = new Float32Array(ab), uv = new Uint32Array(ab);
  fv[0]=params.s0; fv[1]=params.k; fv[2]=params.sigma; fv[3]=params.r;
  fv[4]=params.t; fv[5]=params.isCall?1:0; fv[6]=params.barrier; fv[7]=params.isKnockOut?1:0;
  fv[8]=params.isUp?1:0;
  const optTypeNum = params.optType === 'euro' ? 0 : params.optType === 'asian' ? 1 : 2;
  uv[12]=params.numPaths; uv[13]=params.steps; uv[14]=optTypeNum; uv[15]=seed;
  return ab;
}

// ── GPU 価格評価（価格と標準誤差を返す）──
async function priceGPU(params, seed=12345) {
  const NUM = params.numPaths;
  const payoffBuf = device.createBuffer({ size: NUM*4, usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC });
  const uniBuf = device.createBuffer({ size: 64, usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST });
  const readBuf = device.createBuffer({ size: NUM*4, usage: GPUBufferUsage.MAP_READ | GPUBufferUsage.COPY_DST });
  device.queue.writeBuffer(uniBuf, 0, makeUniform(params, seed));
  const bind = device.createBindGroup({
    layout: pipeline.getBindGroupLayout(0),
    entries: [{ binding:0, resource:{buffer:payoffBuf} }, { binding:1, resource:{buffer:uniBuf} }],
  });
  const enc = device.createCommandEncoder();
  const pass = enc.beginComputePass();
  pass.setPipeline(pipeline); pass.setBindGroup(0, bind);
  pass.dispatchWorkgroups(Math.min(Math.ceil(NUM/64), WG_LIMIT));
  pass.end();
  enc.copyBufferToBuffer(payoffBuf, 0, readBuf, 0, NUM*4);
  device.queue.submit([enc.finish()]);
  await readBuf.mapAsync(GPUMapMode.READ);
  const payoffs = new Float32Array(readBuf.getMappedRange());
  let sum = 0, sumSq = 0;
  for (let i = 0; i < NUM; i++) { sum += payoffs[i]; sumSq += payoffs[i]*payoffs[i]; }
  readBuf.unmap();
  payoffBuf.destroy(); uniBuf.destroy(); readBuf.destroy();
  const mean = sum/NUM, discount = Math.exp(-params.r*params.t);
  const price = mean*discount;
  const variance = sumSq/NUM - mean*mean;
  const se = discount*Math.sqrt(Math.max(variance,0)/NUM);
  return { price, se };
}

// ── CPU 価格評価 ──
function priceCPU(params, seed=12345) {
  const NUM = params.numPaths;
  let sum = 0, sumSq = 0;
  let s_ = seed >>> 0;
  const rng = () => { s_|=0; s_=s_+0x6D2B79F5|0; let t=Math.imul(s_^s_>>>15,1|s_); t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; };
  const dt = params.t/params.steps;
  const drift = (params.r-0.5*params.sigma*params.sigma)*dt;
  const volStep = params.sigma*Math.sqrt(dt);
  const optTypeNum = params.optType==='euro'?0:params.optType==='asian'?1:2;
  for (let i = 0; i < NUM; i++) {
    let s = params.s0, sumS = 0, hit = false;
    for (let step = 0; step < params.steps; step++) {
      const u1=Math.max(rng(),1e-7), u2=rng();
      const z=Math.sqrt(-2*Math.log(u1))*Math.cos(6.2831853*u2);
      s=s*Math.exp(drift+volStep*z); sumS+=s;
      if (params.isUp ? s>=params.barrier : s<=params.barrier) hit=true;
    }
    let payoff=0;
    const vanilla = params.isCall?Math.max(s-params.k,0):Math.max(params.k-s,0);
    if (optTypeNum===0) payoff=vanilla;
    else if (optTypeNum===1){ const a=sumS/params.steps; payoff=params.isCall?Math.max(a-params.k,0):Math.max(params.k-a,0); }
    else { if (params.isKnockOut) payoff=hit?0:vanilla; else payoff=hit?vanilla:0; }
    sum+=payoff; sumSq+=payoff*payoff;
  }
  const mean=sum/NUM, discount=Math.exp(-params.r*params.t);
  const price=mean*discount;
  const variance=sumSq/NUM-mean*mean;
  const se=discount*Math.sqrt(Math.max(variance,0)/NUM);
  return { price, se };
}

async function priceAny(params, seed) {
  return webgpuOK ? await priceGPU(params, seed) : priceCPU(params, seed);
}

// ── Black-Scholes（参考値）──
function normCDF(x){const a1=0.254829592,a2=-0.284496736,a3=1.421413741,a4=-1.453152027,a5=1.061405429,pc=0.3275911;const sign=x<0?-1:1;x=Math.abs(x)/Math.sqrt(2);const t=1/(1+pc*x);const y=1-(((((a5*t+a4)*t)+a3)*t+a2)*t+a1)*t*Math.exp(-x*x);return 0.5*(1+sign*y);}
function blackScholes(S0,K,sigma,r,T,isCall){const d1=(Math.log(S0/K)+(r+0.5*sigma*sigma)*T)/(sigma*Math.sqrt(T));const d2=d1-sigma*Math.sqrt(T);if(isCall)return S0*normCDF(d1)-K*Math.exp(-r*T)*normCDF(d2);return K*Math.exp(-r*T)*normCDF(-d2)-S0*normCDF(-d1);}

// ── 価格評価実行 ──
async function runPricing() {
  document.getElementById('btnPrice').disabled = true;
  document.getElementById('btnGreeks').disabled = true;
  // 価格を再計算したらグリークスは古くなるので一旦隠す
  document.getElementById('greeksGrid').classList.remove('show');
  clearLog();
  const params = getParams();
  if (!validateParams(params)) {
    document.getElementById('btnPrice').disabled = false;
    document.getElementById('btnGreeks').disabled = false;
    return;
  }
  log(`<span class="info">[PRICE]</span> ${params.optType} ${params.isCall?'call':'put'} / ${params.numPaths.toLocaleString()}パス × ${params.steps}step`);
  setProgress(30);
  await new Promise(r => setTimeout(r, 20));

  const t0 = performance.now();
  let res;
  try { res = await priceAny(params); }
  catch(e){ log('<span class="warn">[WARN]</span> GPU失敗、CPUへ'); res = priceCPU(params); }
  const t1 = performance.now();
  setProgress(100);

  document.getElementById('predBox').style.display = 'block';
  document.getElementById('predVal').textContent = res.price.toFixed(4);
  document.getElementById('predSub').textContent = `${params.numPaths.toLocaleString()} paths · SE ±${res.se.toFixed(4)}`;

  const ref = blackScholes(params.s0, params.k, params.sigma, params.r, params.t, params.isCall);
  document.getElementById('statsGrid').classList.add('show');
  document.getElementById('stRef').textContent = ref.toFixed(4);
  document.getElementById('stSE').textContent = '±'+res.se.toFixed(4);
  document.getElementById('stTime').textContent = (t1-t0).toFixed(0)+'ms';

  log(`<span class="ok">[OK]</span> 価格 = ${res.price.toFixed(4)} (${(t1-t0).toFixed(0)}ms)`);
  drawSamplePaths(params);

  document.getElementById('btnPrice').disabled = false;
  document.getElementById('btnGreeks').disabled = false;
  setTimeout(() => setProgress(0), 400);
}

// ── グリークス（有限差分）──
async function runGreeks() {
  document.getElementById('btnPrice').disabled = true;
  document.getElementById('btnGreeks').disabled = true;
  clearLog();
  const base = getParams();
  if (!validateParams(base)) {
    document.getElementById('btnPrice').disabled = false;
    document.getElementById('btnGreeks').disabled = false;
    return;
  }
  log('<span class="info">[GREEKS]</span> 有限差分で5指標を計算中...');

  // 共通シードで分散低減（同じ乱数列で差分を取る）
  const SEED = 777;
  const bump = {
    s: base.s0 * 0.01,    // 株価1%
    vol: 0.01,            // ボラ1%ポイント
    t: 1/365,             // 1日
    r: 0.0001,            // 1bp
  };

  let step = 0; const total = 7;
  const prog = () => { step++; setProgress(step/total*100); };

  const price = async (mod) => {
    const pr = { ...base, ...mod };
    const res = await priceAny(pr, SEED);
    prog();
    await new Promise(r => setTimeout(r, 5));
    return res.price;
  };

  // 基準
  const p0 = await price({});
  // Delta, Gamma: S を ±bump（中心差分）
  const pSup = await price({ s0: base.s0 + bump.s });
  const pSdn = await price({ s0: base.s0 - bump.s });
  const delta = (pSup - pSdn) / (2 * bump.s);
  const gamma = (pSup - 2*p0 + pSdn) / (bump.s * bump.s);
  // Vega: σ を +1%ポイント → 価格変化がそのまま per-1%-Vega
  const pVup = await price({ sigma: base.sigma + bump.vol });
  const vega = pVup - p0;
  // Theta: T を -1日 → 価格変化がそのまま per-day-Theta
  const pTdn = await price({ t: Math.max(base.t - bump.t, 1e-4) });
  const theta = pTdn - p0;
  // Rho: r を +1bp → per-1% に換算（×100）
  const pRup = await price({ r: base.r + bump.r });
  const rho = (pRup - p0) * 100;

  document.getElementById('greeksGrid').classList.add('show');
  document.getElementById('gDelta').textContent = delta.toFixed(4);
  document.getElementById('gGamma').textContent = gamma.toFixed(5);
  document.getElementById('gVega').textContent = vega.toFixed(4);
  document.getElementById('gTheta').textContent = theta.toFixed(4);
  document.getElementById('gRho').textContent = rho.toFixed(4);

  log(`<span class="ok">[OK]</span> Δ=${delta.toFixed(4)} Γ=${gamma.toFixed(5)} ν=${vega.toFixed(4)} Θ=${theta.toFixed(4)} ρ=${rho.toFixed(4)}`);
  setProgress(100);
  document.getElementById('btnPrice').disabled = false;
  document.getElementById('btnGreeks').disabled = false;
  setTimeout(() => setProgress(0), 400);
}

// ── サンプルパス描画 ──
function drawSamplePaths(params) {
  const numSample = 80;
  const steps = Math.min(params.steps < 2 ? 50 : params.steps, 252);
  const dt = params.t / steps;
  const drift = (params.r - 0.5*params.sigma*params.sigma)*dt;
  const volStep = params.sigma*Math.sqrt(dt);
  let s_ = 98765;
  const rng = () => { s_|=0; s_=s_+0x6D2B79F5|0; let t=Math.imul(s_^s_>>>15,1|s_); t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; };

  const paths = [];
  for (let p = 0; p < numSample; p++) {
    const path = [params.s0]; let s = params.s0;
    for (let step = 0; step < steps; step++) {
      const u1=Math.max(rng(),1e-7), u2=rng();
      const z=Math.sqrt(-2*Math.log(u1))*Math.cos(6.2831853*u2);
      s=s*Math.exp(drift+volStep*z); path.push(s);
    }
    paths.push(path);
  }
  const labels = Array.from({length: steps+1}, (_, i) => (i/steps*params.t).toFixed(2));

  const ctx = document.getElementById('pathChart').getContext('2d');
  if (pathChart) pathChart.destroy();
  const datasets = paths.map((path, i) => ({
    label: '', data: path,
    borderColor: `hsla(${190 + (i%40)}, 80%, 60%, 0.22)`,
    borderWidth: 0.7, pointRadius: 0, tension: 0.1,
  }));
  datasets.push({ label:'K (行使価格)', data: labels.map(()=>params.k), borderColor:'rgba(255,107,53,0.85)', borderWidth:1.5, borderDash:[5,3], pointRadius:0 });
  if (params.optType === 'barrier') {
    datasets.push({ label:'Barrier', data: labels.map(()=>params.barrier), borderColor:'rgba(255,68,68,0.9)', borderWidth:1.5, borderDash:[3,2], pointRadius:0 });
  }

  document.getElementById('chartOuter').style.display = 'block';
  pathChart = new Chart(ctx, {
    type: 'line', data: { labels, datasets },
    options: {
      responsive: true, maintainAspectRatio: false, animation: { duration: 250 },
      plugins: { legend: { display:true, labels: { color:'#7a8a9e', font:{family:'DM Mono',size:10}, boxWidth:12, filter:(it)=>it.text!=='' } } },
      scales: {
        x: { title:{display:true,text:'t (年)',color:'#6a7a92',font:{family:'DM Mono',size:10}}, ticks:{color:'#7a8a9e',maxTicksLimit:8,font:{family:'DM Mono',size:10}}, grid:{color:'rgba(30,37,53,.6)'} },
        y: { title:{display:true,text:'株価',color:'#6a7a92',font:{family:'DM Mono',size:10}}, ticks:{color:'#7a8a9e',font:{family:'DM Mono',size:10}}, grid:{color:'rgba(30,37,53,.6)'} }
      }
    }
  });
}

// ── Yahoo Finance からボラティリティ推定 ──
function buildProxies(symbol, range) {
  const selfProxy = 'https://www.iseeit.jp/tools/yf-proxy.php'
    + `?symbol=${encodeURIComponent(symbol)}&range=${encodeURIComponent(range)}`;
  const yfUrl = `https://query1.finance.yahoo.com/v8/finance/chart/${encodeURIComponent(symbol)}`
    + `?interval=1d&range=${range}&events=history`;
  const enc = encodeURIComponent(yfUrl);
  return [
    { name:'iseeit.jp proxy', url: selfProxy, parse: r=>r.json() },
    { name:'corsproxy.io', url:`https://corsproxy.io/?${enc}`, parse: r=>r.json() },
    { name:'allorigins.win', url:`https://allorigins.win/get?disableCache=true&url=${enc}`, parse: async r=>{ const d=await r.json(); return JSON.parse(d.contents); } },
  ];
}
function setPBadge(i, s) { const b=document.getElementById('pb'+i); if(b){ b.className='pbadge '+s; } }

async function fetchYahooVol() {
  const sym = document.getElementById('yfSymbol').value.trim();
  const range = document.getElementById('yfRange').value;
  clearLog();
  [0,1,2].forEach(i => setPBadge(i,''));
  const btn = document.getElementById('fetchBtn');
  btn.disabled = true; btn.textContent = '取得中...';
  log(`<span class="info">[FETCH]</span> ${sym} (${range})`);

  const proxies = buildProxies(sym, range);
  let closes = null;

  for (let i = 0; i < proxies.length; i++) {
    setPBadge(i, 'try');
    log(`<span class="info">[TRY]</span> ${proxies[i].name}`);
    try {
      const res = await Promise.race([
        fetch(proxies[i].url),
        new Promise((_,rej)=>setTimeout(()=>rej(new Error('timeout')),8000))
      ]);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await proxies[i].parse(res);
      const result = json?.chart?.result?.[0];
      if (!result) throw new Error('データなし');
      const q = result.indicators?.quote?.[0];
      if (!q || !q.close) throw new Error('quotes なし');
      closes = q.close.filter(v => v != null);
      if (closes.length < 20) throw new Error('データ不足');
      setPBadge(i, 'ok');
      for (let j=i+1;j<3;j++) document.getElementById('pb'+j).className='pbadge';
      log(`<span class="ok">[OK]</span> ${closes.length} 件の終値を取得`);
      break;
    } catch(e) {
      log(`<span class="warn">[FAIL]</span> ${proxies[i].name}: ${e.message}`);
      setPBadge(i, 'fail');
    }
  }
  btn.disabled = false; btn.textContent = '▶ データ取得してσを推定';

  if (!closes) {
    log('<span class="err">[ERROR]</span> 取得失敗。手動入力タブで σ を設定してください');
    return;
  }

  // 日次対数収益率 → 年率ボラティリティ
  const logRets = [];
  for (let i = 1; i < closes.length; i++) {
    logRets.push(Math.log(closes[i] / closes[i-1]));
  }
  const mean = logRets.reduce((a,b)=>a+b,0) / logRets.length;
  const variance = logRets.reduce((a,b)=>a+(b-mean)**2,0) / (logRets.length-1);
  const dailyVol = Math.sqrt(variance);
  const annualVol = dailyVol * Math.sqrt(252);
  const volPct = Math.round(annualVol * 100);

  // σスライダーに反映
  const sigSlider = document.getElementById('pSig');
  const clamped = Math.max(5, Math.min(80, volPct));
  sigSlider.value = clamped;
  document.getElementById('sigVal').textContent = clamped + '%';

  // 最新終値を S0 に反映（数値入力なので価格レンジ制限なし）
  const lastClose = closes[closes.length-1];
  const s0Input = document.getElementById('pS0');
  s0Input.value = lastClose.toFixed(2);

  const fi = document.getElementById('fileInfo');
  fi.className = 'file-info show';
  fi.innerHTML = `推定ボラティリティ: <strong>${annualVol*100>=100?'>100':(annualVol*100).toFixed(1)}%</strong>（年率）` +
    ` / 最新終値: ${lastClose.toFixed(2)}` +
    (volPct !== clamped ? `<br>※ σは ${clamped}% に丸めました（範囲5〜80%）` : '');

  log(`<span class="ok">[VOL]</span> 年率ボラティリティ = ${(annualVol*100).toFixed(1)}% → σ=${clamped}% に設定`);
  log('<span class="info">[INFO]</span> オプションタイプとパラメータを設定し、価格を計算してください');
}

document.getElementById("dsTabManual").addEventListener("click", () => {
  switchDs('manual');
});
document.getElementById("dsTabYahoo").addEventListener("click", () => {
  switchDs('yahoo');
});
document.getElementById("fetchBtn").addEventListener("click", fetchYahooVol);
document.getElementById("typeTabEuro").addEventListener("click", () => {
  selectType('euro');
});
document.getElementById("typeTabAsian").addEventListener("click", () => {
  selectType('asian');
});
document.getElementById("typeTabBarrier").addEventListener("click", () => {
  selectType('barrier');
});
document.getElementById("btnPrice").addEventListener("click", runPricing);
document.getElementById("btnGreeks").addEventListener("click", runGreeks);

window.addEventListener('load', () => { init(); });
